import { AsYouType, type CountryCode } from "libphonenumber-js";
import type { InputFormatter } from "../types";

export interface PhoneFormatterConfig {
  country: CountryCode;
}

/**
 * Phone number formatter using libphonenumber-js.
 * Formats as user types and parses to digits-only.
 */
export const phoneFormatter: InputFormatter<PhoneFormatterConfig> = {
  format: (value, config) => {
    if (!value) return "";
    try {
      const formatter = new AsYouType(config?.country ?? "AU");
      return formatter.input(value);
    } catch {
      return value;
    }
  },
  parse: (input) => input.replace(/[^\d+]/g, ""),
  keyboardType: "phone-pad",
  autoCapitalize: "none",
};
